import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextHeaderRo = () => {
    return (
        <HighlightedText
            text="FELICITĂRI!"
            highlights={[{ word: 'FELICITĂRI!' }]}
            className={styles.text_header}
        />
    )
}

export const TextContentRo = () => {
    return (
        <HighlightedText
            text="Ați câștigat 400 de rotiri gratuite"
            highlights={[{ word: '400 de rotiri gratuite' }]}
            breakAfterWords={['câștigat', 'rotiri']}
            className={styles['text_content--SECOND']}
        />
    )
}
